import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { "offset-y": "" }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, {
        icon: "",
        class: "mx-1",
        color: "primary"
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("$dots_vertical")
            ])),
            _: 1
          })
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, { nav: "" }, {
        default: _withCtx(() => [
          (_ctx.isAccountingUser && _ctx.type !== 'EXPENSE_REPORT_DOCUMENT')
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTabSync = 'document'))
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("$oss-file")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("Document")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAccountingUser && _ctx.type !== 'EXPENSE_REPORT_DOCUMENT')
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTabSync = 'accountingLines')),
                disabled: _ctx.status !== 'VALIDATED'
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("$oss-accounting-lines")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("Écritures comptables")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.activeTabSync === 'document' && !!_ctx.document.original)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 2,
                onClick: _ctx.startDownloadFile
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("$oss-download")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("Télécharger")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isIncomingOutgoingPayment && _ctx.document.type !== 'EXPENSE_REPORT_DOCUMENT')
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 3,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.accountingLinesLockedDialogSync = true))
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("$oss-edit")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("Écritures manuelles")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.restartAnalysis)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 4,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.analyseDocumentDialogSync = true))
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("$oss-scan")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("Relancer l'analyse")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAccountingUser)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 5,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTabSync = 'activity'))
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("$oss-activity")
                    ])),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("Afficher l'activité")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider, { class: "pb-2" }),
          _createVNode(_component_v_list_item, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteDocumentDialogSync = true)),
            disabled: _ctx.disabledDelete,
            color: "error",
            active: !_ctx.disabledDelete
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "small" }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createTextVNode("$oss-trash")
                ])),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("Supprimer")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled", "active"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}